import type { vaultAvailability, vaultVisibility } from "@/types";
import React, { ReactNode } from "react";
import { SupCheckCircle, SupStar, SupVaultAdd, SupVaultPaused, SupVaultRemove, SupVaultUnavailable } from "@repo/core-ui";

export interface VaultAvailabilityVisibilityConfig<T> {
  value: T;
  name: string;
  icon: ReactNode;
  className?: string;
  color?: string;
  disabled: boolean;
}

const config = () => ({
  vaultAvailabilityTypes: [
    {
      value: "available",
      name: "Available",
      icon: <SupCheckCircle />,
      className: "text-success-600",
      color: "success",
      disabled: false,
    },
    {
      value: "unavailable",
      name: "Unavailable",
      icon: <SupVaultUnavailable />,
      className: "text-warning-600",
      color: "warning",
      disabled: true,
    },
    {
      value: "withdraw_only",
      name: "Withdraw only",
      icon: <SupVaultRemove />,
      className: "text-info-500",
      color: "warning",
      disabled: false,
    },
    {
      value: "deposit_only",
      name: "Deposit only",
      icon: <SupVaultAdd />,
      className: "text-info-500",
      color: "info",
      disabled: false,
    },
    {
      value: "paused",
      name: "Paused",
      icon: <SupVaultPaused />,
      className: "text-warning-600",
      color: "warning",
      disabled: false,
    },
  ] as VaultAvailabilityVisibilityConfig<vaultAvailability>[],
  vaultVisibilityTypes: [
    {
      value: "listed",
      name: "Listed",
      icon: <SupCheckCircle />,
      disabled: false,
    },
    {
      value: "featured",
      name: "Featured",
      icon: <SupStar />,
      disabled: false,
    },
    {
      value: "unlisted",
      name: "Unlisted",
      icon: <SupVaultUnavailable />,
      disabled: true,
    },
    {
      value: "hidden",
      name: "Hidden",
      icon: <SupVaultUnavailable />,
      disabled: false,
    },
  ] as VaultAvailabilityVisibilityConfig<vaultVisibility>[],
});

export default config();
